import importedAxios from 'axios';
import { ConsoleLogger } from '@/services/logger';
import { axiosResponseFulfilledInterceptor } from './response-fulfilled-interceptor';
import { axiosResponseErrorInterceptorFactory } from './response-error-interceptor';
import { axiosRequestFulfilledInterceptor } from './request-fulfilled-interceptor';
import { setRefreshPromise } from './token-refresh';
import { isNoInternetError } from './network-status';
import { env } from '@/config';
import { LogLevel } from '@/constants';

// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const logger = new ConsoleLogger(LogLevel.DEBUG);

/**
 * If it is not a base url (does not start with http) we make sure the first character is a slash ('/')
 *
 * We make sure the last character is NOT a slash ('/')
 *
 * no matter what way parts of the url are provided in env file, we always can be sure about its
 * format after sanitizing
 */
const sanitizeUrl = (url: string): string => {
  let s = url;
  if (!s.startsWith('http')) {
    s = s.replace(/^\/?/, '/');
  }
  return s.replace(/\/$/, '');
};

const { SERVER, APP_VARIANT, SERVER_ENDPOINT } = env;
const API_VERSION = 2;
// console.log({
//   SERVER,
//   SERVER_ENDPOINT,
//   sanitized: {
//     SERVER: sanitizeUrl(SERVER),
//     SERVER_ENDPOINT: sanitizeUrl(SERVER_ENDPOINT)
//   }
// });

const keycloakAxios = importedAxios.create({
  baseURL: `${sanitizeUrl(SERVER)}${sanitizeUrl(SERVER_ENDPOINT)}/`,
  timeout: 5000,
  headers: {
    'X-API-VERSION': `${API_VERSION}`,
    ['X-APP-VARIANT']: APP_VARIANT,
    'Content-Type': 'application/json',
    Accept: 'application/json'
  },
  responseType: 'json'
});
keycloakAxios.interceptors.request.use(axiosRequestFulfilledInterceptor);
keycloakAxios.interceptors.response.use(
  axiosResponseFulfilledInterceptor,
  axiosResponseErrorInterceptorFactory(keycloakAxios)
);

export { setRefreshPromise, isNoInternetError };
export default keycloakAxios;
